import { createApi } from '@reduxjs/toolkit/query/react';
import { fetchApiQuery } from '../../apiClient/ai-api-client';

export const aiApi = createApi({
  reducerPath: 'aiApi',
  baseQuery: fetchApiQuery,
  endpoints: (builder) => ({
    getFeedbacks: builder.query({
      query: ({ liked, search, startDate, endDate, page = 1, pageSize = 10 }) => ({
        url: `/conversation/feedbacks?${liked !== '' ? `liked=${liked}&` : ''}${startDate ? `start_date=${startDate}&` : ''}${endDate ? `end_date=${endDate}&` : ''}`,
        params: {
          search: search,
          limit: pageSize,
          offset: (page - 1) * pageSize,
        },
      }),
    }),
    getConversationMessages: builder.query({
      query: (conversationId) => ({
        url: `/conversation/${conversationId}/messages`,
      }),
    }),
  }),
});

export const { useGetFeedbacksQuery, useGetConversationMessagesQuery } = aiApi;
